document.addEventListener('DOMContentLoaded', () => {
  const checkbox = document.querySelectorAll('input[type="checkbox"]')

  checkbox?.forEach((item) => {
    item.addEventListener('keypress', function (e) {
      e.preventDefault()

      if (e.which === 13) {
        this.checked = !this.checked
        item.focus()

        item.dispatchEvent(new Event('input', { bubbles: true }))
      }
    })
  })
})
